import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConstants } from '../../app.constants';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';

export interface SectionWiseEmailRequest {
  user_email: string;
  html_content: string;
  section: string; // e.g. "IP_section"
   subject: string;
}

@Injectable({
  providedIn: 'root'
})
export class SectionWiseEmailService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) { }

  sendSectionWiseEmail(payload: SectionWiseEmailRequest): Observable<any> {
    return this.http
      .post(
        `${AppConstants.API_ENDPOINT}${AppConstants.API.SECTION_WISE_EMAIL.SEND_EMAIL}`,
        payload
      )
      .pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
